import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApi, useWorkspace } from '~/contexts';
import { ErrorPage } from '~/routes/public/pages';
import ProjectTaskForm from './ProjectTaskForm';
import ProjectTaskGroupForm from './ProjectTaskGroupForm';

function ProjectTaskEditDrawer({ taskId, project, onSaved, onClose, onDelete }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const params = useParams();
  if (!taskId) taskId = params.taskId;

  const [{ isReady, task }, setTask] = useState({ isReady: false, task: null });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.www.workspaces(workspace.id).projects(project.id).tasks(taskId).get();
        setTask({ isReady: true, task: data });
      } catch {
        setTask({ isReady: true, task: null });
      }
    })();
  }, [api, workspace.id, project.id, taskId]);

  if (!isReady) return null;
  if (!task) return <ErrorPage.NotFound publicSite={false} />;

  const Form = task.mode === 'group' ? ProjectTaskGroupForm : ProjectTaskForm;
  return <Form task={task} project={project} onSaved={onSaved} onClose={onClose} onDelete={onDelete} />;
}

export default ProjectTaskEditDrawer;
